import React from "react";

export default function CompetencySelector({ competencies, selectedIndexes, onSelectionChange, disabled }) {
  const handleToggle = (index) => {
    if (disabled) return;
    const isSelected = selectedIndexes.includes(index);
    const updated = isSelected
      ? selectedIndexes.filter((i) => i !== index)
      : [...selectedIndexes, index];
    onSelectionChange(updated);
  };

  return (
    <div className="competency-selector">
      <div className="competency-selector-header">
        <span className="competency-selector-title">Select competencies</span>
        <span className="competency-selector-count">
          {selectedIndexes.length} of {competencies.length} selected
        </span>
      </div>
      <div className="competency-selector-grid">
        {competencies.map((comp, idx) => {
          const index = comp.index ?? idx;
          const isSelected = selectedIndexes.includes(index);
          return (
            <button
              key={index}
              className={`competency-cell ${isSelected ? "selected" : ""}`}
              onClick={() => handleToggle(index)}
              disabled={disabled}
              type="button"
            >
              {comp.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
